// extracted by mini-css-extract-plugin
export default {"garan":"fBDbppua","nested":"JqzeRCOO","nestedSvg":"Gm6Q44Ue","full":"anet5o89","fullSvg":"doi0W3Mg","link":"KX6aZ9s1"};